<template>
  <h2 class="headline-lg medium">{{text}}</h2>
  <button  v-show="showModal != true" @click="showModal = true" class="button outline">Vælg Recruiter</button>
  <div v-if="showModal" class="modal">
    <ul>
        <li v-for="recruiter in recruiters" :key="recruiter">
            <a href="#" @click="selectRecruiter(recruiter)" >{{ recruiter }}</a>
        </li>
    </ul>
    <button @click="showModal = false" class="button outline">Luk</button>
  </div>
</template>

<script>
    export default {
        props: {
            recruiters: Array
        },
        data(instance) {
            return {
                showModal: false,
                values: instance.store[instance.store.currentCulture].values.productDetails,
                text: 'Vælg recruiter'
            };
        },
        mounted() {
            // Check if a recruiter was preselected via query parameter
            if (this.values.recruiter) {
                this.text = "Recruiter: " + this.values.recruiter;
            }
        },
        methods: {
            selectRecruiter(recruiter) {
                this.values.recruiter = recruiter;
                this.showModal = false;
                this.text = "Recruiter: " + recruiter;
            }
        }
    }
</script>
<style scoped lang="postcss">
.modal {
    width:100%;
}
ul {
    margin-top:20px;
    list-style: none;
    
    li a {
        text-decoration: underline;
    }
}
</style>